import { createContext, ReactChild, useCallback, useContext, useState } from 'react';

interface AuthProviderProps {
  children: ReactChild | ReactChild[];
}

interface ILoaderContext {
  loading: boolean;
  message: string;
  showLoader: (msg?: string) => void;
  hideLoader: () => void;
}

const LoaderContext = createContext<ILoaderContext>({
  loading: false,
  message: '',
  showLoader: () => null,
  hideLoader: () => null,
});

function LoaderProvider({ children }: AuthProviderProps): JSX.Element {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const showLoader = useCallback((msg) => {
    setMessage(msg);
    setLoading(true);
  }, []);

  const hideLoader = useCallback(() => {
    setLoading(false);
    setMessage('');
  }, []);

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader, message }}>{children}</LoaderContext.Provider>
  );
}

function useLoader(): ILoaderContext {
  const loaderContext = useContext(LoaderContext);

  if (!loaderContext) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }

  return loaderContext;
}

export { LoaderProvider, useLoader };
